var _rect, _path, _path2, _path3, _mask, _rect2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMonitor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 220,
    viewBox: "0 0 219 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 218.182,
    height: 220,
    rx: 15,
    fill: "#5D38E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.392 168.9H49.3133C48.402 168.9 47.6633 168.161 47.6633 167.25V52.2208C47.6633 50.7475 49.4474 50.0128 50.4848 51.0589L164.563 166.088C165.596 167.129 164.858 168.9 163.392 168.9Z",
    stroke: "white",
    strokeWidth: 6.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.798 167.25C172.798 171.37 169.491 174.675 165.455 174.675C161.419 174.675 158.112 171.37 158.112 167.25C158.112 163.13 161.419 159.825 165.455 159.825C169.491 159.825 172.798 163.13 172.798 167.25Z",
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 4.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6164 50.1C56.6164 54.2201 53.3095 57.525 49.2733 57.525C45.2371 57.525 41.9301 54.2201 41.9301 50.1C41.9301 45.9798 45.2371 42.675 49.2733 42.675C53.3095 42.675 56.6164 45.9798 56.6164 50.1Z",
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 4.95
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_93_1926",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.3633,
    y: 139.2,
    width: 32.7273,
    height: 33,
    rx: 3.3
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.3633,
    y: 139.2,
    width: 32.7273,
    height: 33,
    rx: 3.3,
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 13.2,
    mask: "url(#path-5-inside-1_93_1926)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6164 167.25C56.6164 171.37 53.3095 174.675 49.2733 174.675C45.2371 174.675 41.9301 171.37 41.9301 167.25C41.9301 163.13 45.2371 159.825 49.2733 159.825C53.3095 159.825 56.6164 163.13 56.6164 167.25Z",
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 4.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMonitor);
export default __webpack_public_path__ + "static/media/icon_monitor.c499a229ec56766cd9ada90575d5ee59.svg";
export { ForwardRef as ReactComponent };